import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../../apiClient'

export const USE_ONTOLOGY_PREDICTION_CORRECTION_CRITICAL_ERRORS_KEY =
  'ontology-prediction-correction-critical-errors'

export type CriticalErrorDefinition = {
  groundTruthFeatureId: string
  criticalResponseFeatureIds: string[]
}

export type CriticalErrorMatrix = {
  definitions: CriticalErrorDefinition[]
}

type UseGetOntologyPredictionCorrectionCriticalErrors = {
  programId?: string
  predictionCorrectionId?: string
}

export function useGetOntologyPredictionCorrectionCriticalErrors(
  params: UseGetOntologyPredictionCorrectionCriticalErrors
) {
  return useQuery({
    queryKey: [USE_ONTOLOGY_PREDICTION_CORRECTION_CRITICAL_ERRORS_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.get<CriticalErrorMatrix>(
        `/int/v3/programs/${params.programId}/ontology/prediction-corrections/${params.predictionCorrectionId}/critical-errors`
      )
      return data
    },
    enabled: Boolean(params.programId) && Boolean(params.predictionCorrectionId),
    refetchOnWindowFocus: false,
  })
}
